<template>
  <material-card
    :title="$t('components.dependantsimportwizardcomponent.import_dependants')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="publish"
  >
    <v-card-text>
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">
            {{ $t("globals.cancel_wizard") }}
          </v-card-title>
          <v-card-text>
            {{
              $t(
                "components.inmemorystores.if_you_exit_the_wizard_any_changes_made_so_far"
              )
            }}
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="dialog = false">{{
              $t("globals.keep_working")
            }}</v-btn>
            <v-btn color="primary" @click="cancel()">
              {{ $t("globals.cancel_anyway") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-subheader class="pa-0">
        {{
          $t(
            "components.dependantsimportwizardcomponent.you_are_few_steps_away_from_importing_dependants"
          )
        }}
      </v-subheader>
      <v-stepper v-model="e6" vertical class="elevation-0">
        <v-stepper-step :complete="e6 > 1" step="1">
          {{
            $t(
              "components.membersimportwizardcomponent.download_data_template_optional"
            )
          }}
          <small>
            {{
              $t(
                "components.membersimportwizardcomponent.download_and_use_a_data_template_in_xlsx_format_you"
              )
            }}
          </small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-container fluid>
            <v-row fluid>
              <v-col class="col-auto">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      slot="activator"
                      color="success"
                      :loading="downloading"
                      :disabled="downloading"
                      v-on="on"
                      >{{
                        $t("globals.download")
                      }}</v-btn
                    >
                  </template>
                  <v-list>
                    <v-list-item @click="downloadTemplate(false)">
                      <v-list-item-title>{{
                        $t("components.membersimportwizardcomponent.empty")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadTemplate(true)">
                      <v-list-item-title>
                        {{
                          $t(
                            "components.dependantsimportwizardcomponent.all_dependants"
                          )
                        }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col class="col-auto">
                <v-dialog v-model="validationTipsDialog" width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn color="success" dark v-on="on">{{
                      $t(
                        "components.membersimportwizardcomponent.validation_rules"
                      )
                    }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title
                      style="background:#4caf50;color: white;"
                      class="headline lighten-2"
                      primary-title
                      >{{
                        $t(
                          "components.membersimportwizardcomponent.validation_rules"
                        )
                      }}</v-card-title
                    >
                    <v-card-text>
                      <div style="padding-top:5px"></div>
                      <strong
                        >{{
                          $t("components.membersimportwizardcomponent.dates")
                        }}: </strong
                      >{{
                        $t(
                          "components.membersimportwizardcomponent.columns_that_contain_date_values_must_have_their_format_cell"
                        )
                      }}
                      <v-divider />
                      <strong
                        >{{
                          $t(
                            "components.membersimportwizardcomponent.selection_columns"
                          )
                        }}: </strong
                      >{{
                        $t(
                          "components.membersimportwizardcomponent.those_columns_should_contain_values_that_are_valid_names_eg"
                        )
                      }}
                      <v-divider />
                      <div v-if="columns">
                        <strong
                          >{{
                            $t(
                              "components.membersimportwizardcomponent.required_columns"
                            )
                          }}:
                        </strong>
                        <span>{{
                          columns
                            .filter((f) => !f.isOptional && f.usedInBulkImport)
                            .map((f) =>
                              $t("headers.memberdependants." + f.name)
                            )
                            .join(", ")
                        }}</span>
                        <v-divider />
                        <strong
                          >{{
                            $t(
                              "components.membersimportwizardcomponent.optional_columns"
                            )
                          }}:
                        </strong>
                        <span>{{
                          columns
                            .filter((f) => f.isOptional && f.usedInBulkImport)
                            .map((f) =>
                              $t("headers.memberdependants." + f.name)
                            )
                            .join(", ")
                        }}</span>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="primary"
                        text
                        @click="validationTipsDialog = false"
                        >{{ $t("globals.close") }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col class="col-auto">
                <v-btn color="primary" @click="e6 = 2">
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <v-stepper-step :complete="e6 > 2" step="2">
          {{ $t("components.membersimportwizardcomponent.upload_data") }}
          <small>
            {{
              $t(
                "components.membersimportwizardcomponent.choose_the_file_to_import_data_from_using_the_select"
              )
            }}
          </small>
        </v-stepper-step>
        <v-stepper-content step="2">
          <div>
            <file-uploader
              ref="uploader"
              :label="$t('views.billingwizard.billing_import_select')"
              accept=".xlsx"
              :uploading="uploading"
              :url="apiURL"
              v-on:upload-started="onUploadStarted"
              v-on:upload-error="onUploadError"
              v-on:upload-completed="onUploadCompleted"
              @lock-expired="$emit('close')"
            ></file-uploader>
          </div>
          <span v-if="uploading">{{
            $t("components.membersimportwizardcomponent.please_wait")
          }}</span>
          <div v-if="uploaded && uploadedOK">
            <v-banner
              icon="done"
              color="success"
              elevation="0"
              icon-color="white"
              >{{ $t(uploadResult) }}</v-banner
            >
          </div>
          <template v-for="(error, i) in uploadErrors">
            <v-alert dense type="error" :key="i">{{ $t(error) }}</v-alert>
          </template>
          <v-card-actions>
            <v-btn :disabled="uploading" text @click="e6 = 1">
              {{ $t("globals.back") }}
            </v-btn>
            <v-col class="col-auto">
              <v-btn
                :disabled="!uploaded || !uploadedOK"
                color="primary"
                @click="e6 = 3"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-stepper-content>
        <v-stepper-step :complete="e6 > 3" step="3">
          {{ $t("components.membersimportwizardcomponent.match_columns") }}
          <small>
            {{
              $t(
                "components.membersimportwizardcomponent.match_detected_fields_with_actual_fields_your_data_will_be"
              )
            }}
          </small>
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-card-text>
            <v-form v-model="valid">
              <v-list>
                <v-subheader>{{ $t("validation.required") }}</v-subheader>
                <v-container fluid>
                  <v-row>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="3"
                      v-for="item in requiredColumns"
                      :key="item"
                    >
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>
                          <auto-select
                            :value.sync="columnsAssociations[item]"
                            :items="detectedColumns"
                            :label="
                              $t(
                                'components.membersimportwizardcomponent.detected'
                              )
                            "
                            :rules="[$rules.required]"
                            class="required"
                          ></auto-select>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>

                <v-subheader>{{
                  $t("components.plancreationwizard.optional")
                }}</v-subheader>
                <v-container fluid>
                  <v-row>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="3"
                      v-for="item in optionalColumns"
                      :key="item"
                    >
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>

                          <auto-select
                            clearable
                            :value.sync="columnsAssociations[item]"
                            :items="detectedColumns"
                            :label="
                              $t(
                                'components.membersimportwizardcomponent.detected'
                              )
                            "
                          ></auto-select>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list>
            </v-form>
            <div v-if="confirmed">
              <v-banner
                icon="done"
                color="success"
                elevation="0"
                icon-color="white"
                >{{
                  $t(
                    "components.dependantsimportwizardcomponent.total_{0}_dependants_added",
                    [membersAdded]
                  )
                }},
                {{
                  $t(
                    "components.dependantsimportwizardcomponent.total_{0}_dependants_updated",
                    [membersUpdated]
                  )
                }}</v-banner
              >
            </div>
            <template v-for="(error, i) in errors">
              <v-alert dense type="error" :key="i">{{ $t(error) }}</v-alert>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="
                e6 = 2;
                unlock();
              "
            >
              {{ $t("globals.back") }}
            </v-btn>
            <v-btn
              color="primary"
              @click="confirmMatch()"
              :disabled="!valid || confirmed"
              :loading="loading"
            >
              {{ $t("components.membersimportwizardcomponent.confirm_match") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>
      </v-stepper>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        :disabled="confirmed || uploading || loading"
        text
        @click="dialog = true"
        >{{ $t("globals.cancel") }}</v-btn
      >
      <v-btn color="primary" @click="finish()" :disabled="!confirmed">
        {{ $t("globals.finish") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import FileUploader from "../components/FileUploader";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import TransSelect2 from "../components/TransSelect2";
import AutoSelect from "../components/AutoSelect";

export default {
  name: "dependants-import-wizard-component",
  props:["term"],
  components: {
    FileUploader,
    ErrorHandler,
    TransSelect2,
    AutoSelect
  },
  data() {
    return {
      termValid:false,
      uploadErrors: [],
      loading: false,
      membersAdded: [],
      membersUpdated: [],
      errors: [],
      confirmed: false,
      guid: null,
      columnsAssociations: {},
      requiredColumns: [],
      optionalColumns: [],
      detectedColumns: [],
      error: null,
      e6: 1,
      dialog: false,
      validationTipsDialog: false,
      validationErrors: [],
      validating: false,
      validated: false,
      valid: false,
      uploaded: false,
      uploading: false,
      uploadResult: "",
      apiURL: null,
      uploadedOK: false,
      allowUpload: false,
      downloading: false,
      headers: [],
      members: [],
      fileValidationErrors: [],
      fileValidationMessages: [],
      fileUploadRules: [],
      columns: [],
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", {
      settings: "settings",
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planColumnsOptions: "planOptions",
    }),
  },
  watch: {
    e6: {
      handler(v) {
        switch (v) {
          case 1: {
            
            break;
          }
          case 2: {
            this.$refs.uploader.reset();
            this.uploaded = false;
            this.uploadedOK = false;
            this.uploadResult = "";
            this.confirmed = false;
            this.uploadErrors = [];
            this.errors = [];
            this.uploading = false;
            this.loading = false;
            break;
          }
          default: {
            break;
          }
        }
      },
    },
  },
  async mounted() {
    this.apiURL =
              this.settings.APIURL +
              "plans/" +
              this.selectedPlan.Id +
              "/dependant-import";
    await this.init();
  },
  beforeDestroy() {
    this.unlock();
  },
  methods: {
    unlock() {
      this.$refs.uploader.unlock();
    },
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "getMembers",
      "postConfirmMatchDependants",
      "getBlobAsync",
    ]),
    ...mapActions("data", ["fetchFile", "setHost", "validate"]),
    async confirmMatch() {
      try {
        this.loading = true;
        //const url = "http://localhost:5011/MemberImport/Plan/" + this.selectedPlan.Id + "/Parse/" + this.guid;
        //const res = (await this.postAsync({url: url, payload: this.columnsAssociations})).data;
        const res = (await this.postConfirmMatchDependants({
          guid: this.guid,
          plan: this.selectedPlan.Id,
          payload: this.columnsAssociations
        })).data;
        this.membersAdded = res.membersAdded;
        this.membersUpdated = res.membersUpdated;
        this.confirmed = true;
        this.unlock();
      } catch (error) {
        if (error.response) {
          //console.log(error.response.data);
          if (Array.isArray(error.response.data)) {
            //console.log("array");
            this.errors = error.response.data.slice(0, 100);
          } else {
            this.errors = ["globals.server_error"];
          }
        } else this.error = error;
      }
      this.loading = false;
    },
    reset() {
      this.$refs.uploader.reset();
      this.e6 = 1;
      this.uploaded = false;
      this.uploadedOK = false;
      this.uploadResult = "";
      this.confirmed = false;
      this.uploadErrors = [];
      this.errors = [];
    },
    finish() {
      this.reset();
      this.$emit("finish");
    },

    async init() {
      this.confirmed = false;
      this.uploaded = false;
      this.uploading = false;
      if (this.selectedPlan != null) {
        this.uploadResult = "";
        this.columns = [
          {
            name:"certificate",
            text:"Certificate",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"firstname",
            text:"First Name",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"middlename",
            text:"Middle Name",
            usedInBulkImport:true,
            isOptional:true
          },
          {
            name:"lastname",
            text:"Last Name",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"relationship",
            text:"Relationship",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"effectivedate",
            text:"Effective Date",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"gender",
            text:"Gender",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"student",
            text:"Student",
            usedInBulkImport:true,
            isOptional:true
          },
          {
            name:"dateofbirth",
            text:"Date of Birth",
            usedInBulkImport:true,
            isOptional:false
          },
          {
            name:"dateofmarriage",
            text:"Date of Marriage or Common Law Status",
            usedInBulkImport:true,
            isOptional:true
          },
          {
            name:"schoolcompletiondate",
            text:"School Completion Date",
            usedInBulkImport:true,
            isOptional:true
          },
          {
            name:"smoker",
            text:"Smoker",
            usedInBulkImport:true,
            isOptional:true
          }
        ]
      }
    },
    cancel() {
      this.dialog = false;
      this.reset();
      this.unlock();
      this.$emit("close");
    },
    onUploadStarted() {
      this.uploaded = false;
      this.uploading = true;
    },
    onUploadCompleted(res) {
      this.uploaded = true;
      this.uploadedOK = true;
      this.uploading = false;
      //console.log(res);
      this.requiredColumns = res.required;
      this.optionalColumns = res.optional;
      this.detectedColumns = res.detected;
      this.columnsAssociations = res.associations;
      this.guid = res.guid;
      this.uploadErrors = [];
      this.uploadResult = "globals.upload_result";
      this.e6 = 2;
    },
    onUploadError(err) {
      //console.log("ERR");
      //console.log(JSON.stringify(err));
      this.uploaded = true;
      this.uploadedOK = false;
      this.uploading = false;
      //console.log(err.response.data);
      if (Array.isArray(err.response.data)) {
        this.uploadErrors = err.response.data.slice(0, 100);
      } else {
        // this.uploadErrors = ["Server error"];
        this.error = err;
      }
    },

    async downloadTemplate(filled) {
      this.downloading = true;
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/dependant-import" +
        (filled
          ? "/with-data"
          : "");

      const filename = "Template.xlsx";
      try {
        let blob = (await this.getBlobAsync({ url: url }))
          .data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      }
      this.downloading = false;
    },
  },
};
</script>

<style>
.with-margin {
  margin: 20px;
}
.maxwidth {
  max-width: 800px;
}
</style>
